/**
 * patrol-other-edit.js
 */

import React from 'react';
import { shouldRenderMobileLayout } from 'utils/app-context';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HiddenInput from 'components/form-inputs/hidden-input';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolOtherEdit(props) {
  const {
    patrolRecord,
    patrolIndex,
    patrolTypes,
    translation,
    formPrefix=''
  } = props;
  const formNameBase = `${formPrefix}patrol.patrolTypes[${patrolIndex}].other`;
  const typeRecord = patrolRecord?.other;


  return (
    <>
      <EditorIconSection
        iconName='patrol-other'
        iconMarginTop={0}
        helpProps={{
          translation,
          section: 'other',
          suffix: patrolTypes.length > 1 ? ` (Scenario)` : '',
        }}
      >
        {!shouldRenderMobileLayout() &&
        <PatrolTypeTitle 
          patrolType={patrolRecord.type} 
          patrolTypes={patrolTypes} 
          step={patrolRecord.order}
        />}

        {/* id */}
        <HiddenInput 
          name={`${formNameBase}.id`}
          defaultValue={typeRecord?.id || ''}
        />
      </EditorIconSection>
    </>
  );
}